module.exports = __webpack_public_path__ + "static/media/06.Bhasakr Kogga Kamath with Puppets.cccd0ee6.jpg";